import api from '../http';
import { AxiosResponse } from 'axios';
import { DayPromoCode, Invoice } from '../models/payment';


export interface CreateInvoiceResponse {
    invoice_link: string,
    invoice_id: number
}

export interface GetInvoiceResponse {
    invoice: Invoice
}

export interface SubmitPromoCodeResponse {
    percent_bonus: number
}

export default class PaymentService {
    static async createInvoice(productId: string, systemName: string): Promise<AxiosResponse<CreateInvoiceResponse>> {
        return await api.post(
            'payment/invoice',
            {
                product_id: productId,
                system_name: systemName
            }
        ); 
    };

    static async createDepositInvoice(deposit: number, promoCode: string | null): Promise<AxiosResponse<CreateInvoiceResponse>> {
        return await api.post(
            'payment/invoice/deposit',
            {
                deposit: deposit,
                promo_code: promoCode !== null ? promoCode.trim() : promoCode
            }
        ); 
    };

    static async submitPromoCode(promoCode: string): Promise<AxiosResponse<SubmitPromoCodeResponse>> {
        return await api.post(
            'payment/promo_code',
            {
                promo_code: promoCode.trim()
            }
        ); 
    };

    static async getDayPromoCode(): Promise<AxiosResponse<DayPromoCode>> {
        return await api.get('payment/promo_code/day'); 
    };

    static async getInvoice(invoiceId: number): Promise<AxiosResponse<GetInvoiceResponse>> {
        return await api.get(
            'payment/invoice',
            {params: {
                invoice_id: invoiceId,
            }}
        );
    };
};